export default __webpack_public_path__ + "static/media/yourPrivacyChoice.e8f561f6.svg";